export default __webpack_public_path__ + "static/media/Directory.401c354e.svg";